import { render, staticRenderFns } from "./CategoryRangeFilter.vue?vue&type=template&id=8754b114&scoped=true&name=range-filter&"
import script from "./CategoryRangeFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryRangeFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRangeFilter.vue?vue&type=style&index=0&id=8754b114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8754b114",
  null
  
)

export default component.exports